const fromArray = (array: any[]): string => array && array.join();
const toNumber = (value: any): number => value && Number(value);

const formatMobileNumberIn = (mobileNumber: string): string =>
    mobileNumber.replace(/^[+]64/g, '0');

const formatMobileNumberOut = (mobileNumber: string): string =>
    mobileNumber.replace(/^0/, '+64');

export default {
    fromArray,
    toNumber,
    formatMobileNumberIn,
    formatMobileNumberOut
};
